var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-footer-button"},[_c('button',{staticClass:"btn share-footer-button__btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }